import React from 'react';

import './ItemCount.scss';

interface ItemCountProps {
    count: number | undefined;
}
export const ItemCount = ({ count }: ItemCountProps) => {
    return count ? (
        <div className="yat-artifacts-item-count">
            <p className={'yat-artifacts-item-count__label'}>{count}</p>
        </div>
    ) : null;
};
